import { InnerBox } from "@/components/elements/InnerBox";
import { ReadonlyEmailField } from "@/features/user-setting/components/change-email/ReadonlyEmailField";
import { Stack } from "@mui/material";
import { FC } from "react";

type TEmailChangeReviewProps = {
  currentEmail?: string | null;
  newEmail: string;
};

export const EmailChangeReview: FC<TEmailChangeReviewProps> = ({ currentEmail, newEmail }) => {
  return (
    <InnerBox padding="24px">
      <Stack gap="16px">
        <ReadonlyEmailField label="現在のメールアドレス" email={currentEmail} />
        <ReadonlyEmailField label="新しいメールアドレス" email={newEmail} />
      </Stack>
    </InnerBox>
  );
};
